// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__2vSb6","card":"Card_card__3C6Cc"};